/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSON,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    error_type: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerErrorTypeEnum;
    /**
     * 
     * @type {MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    metadata?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata;
    /**
     * 
     * @type {Date}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    dismissed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    recovered_at?: string;
    /**
     * 
     * @type {Date}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner
     */
    deleted_at?: Date;
}


/**
 * @export
 */
export const MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerErrorTypeEnum = {
    TooManyDocuments: 'TOO_MANY_DOCUMENTS',
    DownloadError: 'DOWNLOAD_ERROR',
    DocumentTooLarge: 'DOCUMENT_TOO_LARGE',
    DocumentNotRelevant: 'DOCUMENT_NOT_RELEVANT'
} as const;
export type MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerErrorTypeEnum = typeof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerErrorTypeEnum[keyof typeof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerErrorTypeEnum];


/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "error_type" in value;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'error_type': json['error_type'],
        'metadata': !exists(json, 'metadata') ? undefined : MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSON(json['metadata']),
        'dismissed_at': !exists(json, 'dismissed_at') ? undefined : (new Date(json['dismissed_at'])),
        'recovered_at': !exists(json, 'recovered_at') ? undefined : json['recovered_at'],
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updated_at': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'deleted_at': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerToJSON(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'document_id': value.document_id,
        'error_type': value.error_type,
        'metadata': MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSON(value.metadata),
        'dismissed_at': value.dismissed_at === undefined ? undefined : (value.dismissed_at.toISOString()),
        'recovered_at': value.recovered_at,
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'updated_at': value.updated_at === undefined ? undefined : (value.updated_at.toISOString()),
        'deleted_at': value.deleted_at === undefined ? undefined : (value.deleted_at.toISOString()),
    };
}

